<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { isUsageSummary, type UsageSummary } from '@calloneer/contracts';
import { apiRequest } from '../api.js';
const usage = ref<readonly UsageSummary[]>([]);
const isUsage = (value: unknown): value is readonly UsageSummary[] =>
  Array.isArray(value) && value.every(isUsageSummary);
onMounted(async () => {
  usage.value = await apiRequest({ path: '/v1/me/usage', guard: isUsage });
});
</script>

<template>
  <section>
    <p class="eyebrow">AUTHORITATIVE PROVIDER TOTALS</p>
    <h1>Usage</h1>
    <div class="stat-grid">
      <article v-for="item in usage" :key="item.currency" class="panel stat">
        <p>{{ item.currency }}</p>
        <strong>{{ item.cost }}</strong
        ><span
          >{{ item.callCount }} calls · {{ item.connectedMinutes.toFixed(1) }} connected
          minutes</span
        >
      </article>
      <article v-if="usage.length === 0" class="panel empty">No reconciled usage yet.</article>
    </div>
  </section>
</template>
